import './ClassicEventView.scss';
import { useTranslation } from 'react-i18next';
import { eventActivityType } from '../../constants/myBlockMonth';
import { getDateInWeekDayMonthDateFormat } from '../../helpers/dateHelpers';
import { formatNumToTime } from '../../helpers/timeHelpers';

function ClassicReleaseEventDetail({activityType, event}) {
    const { t } = useTranslation();
    
    return (
        <>
            <div className="cv_specialEvent_release_container">
                <div className={activityType === eventActivityType.PAIRING ? 'cv_releasePairing_header' : 'cv_release_header'}>{t('myBlockMonth.release')}</div>
                <div className="cv_specialEvent_release_details" style={{width:activityType === eventActivityType.RAP ? '35.4rem' : ''}}>
                    <p className={activityType === eventActivityType.PAIRING ? 'cv_specialEvent_releasePairing_headervalue' : 'cv_specialEvent_release_headervalue'}>{t('myBlockMonth.start')}:</p>
                    <p className="cv_specialEvent_release_datevalue">{getDateInWeekDayMonthDateFormat(new Date(event?.start_date + ' 00:00'))}</p>
                    <p className="cv_specialEvent_release_timevalue">{formatNumToTime(event?.checkIn?.value)} ET</p>
                </div>
                <div className="cv_specialEvent_release_details" style={{width:activityType === eventActivityType.RAP ? '25rem' : ''}}>
                    <p className="cv_specialEvent_release_header">{t('myBlockMonth.end')}:</p>
                    <p className="cv_specialEvent_release_datevalue">{getDateInWeekDayMonthDateFormat(new Date(event?.end_date + ' 00:00'))}</p>
                    <p className="cv_specialEvent_release_timevalue">{formatNumToTime(event?.checkOut?.value)} ET</p>
                </div>
                <div className="cv_specialEvent_release_details">
                    <p className="cv_specialEvent_release_header" style={{marginLeft: activityType === eventActivityType.RAP  ? '0' :'0.4rem'}}>{t('myBlockMonth.duration')}:</p>
                    <p className="cv_specialEvent_release_values">{event.duration}</p>
                </div>
            </div>
            {activityType === eventActivityType.PAIRING ? <div className="cv_specialEvent_rp_divider"></div> : null}
        </>
    );
}

export default ClassicReleaseEventDetail;